import { render, staticRenderFns } from "./DynamicFormFieldText.vue?vue&type=template&id=4dfa898f&"
import script from "./DynamicFormFieldText.vue?vue&type=script&lang=js&"
export * from "./DynamicFormFieldText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports